import { PickPublic } from '../lib/utils.ts'
import { Vocabulary } from './chatApi.ts'
import { HttpClient } from './httpClient.ts'

export type WordsApi = PickPublic<AppWordsApi>

export class AppWordsApi {
  constructor(private httpClient: HttpClient) {}

  wordAdd(request: { word_original: string; course_id?: number | null }) {
    const body: { word_original: string; course_id?: number } = {
      word_original: request.word_original,
    }
    if (request.course_id != null) body.course_id = request.course_id
    return this.httpClient.post<Vocabulary>('/api/vocabulary/add/', body)
  }

  wordRemove(id: number) {
    return this.httpClient.del<Vocabulary>(`/api/vocabulary/remove/${id}/`, {})
  }

  getWords(
    requestParams: {
      is_user_added?: boolean
      limit?: number
      offset?: number
      ordering?: string
      timestamp?: string
      course_id?: number | null
    } = {},
  ) {
    const { course_id, ...rest } = requestParams
    const params: Record<string, string | number | boolean> = {}
    Object.entries(rest).forEach(([k, v]) => {
      if (v != null && v !== '') params[k] = v
    })
    if (course_id != null) params.course_id = course_id
    return this.httpClient.get<Vocabulary[]>('/api/vocabulary/', params)
  }
}
